import React, {
  Context,
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';
import { forwardUrlParams } from '../utils';
import { useHistory } from 'react-router';
import { getLead } from '../components/API/lead';
import { ESellerStore } from '../Types/business';

export interface GetStarted {
  leadId: string;
  setLeadId: (...args) => void;
  onboardingStage: number;
  setOnboardingStage: (...args) => void;
  email: string;
  setEmail: (...args) => void;
  name: string;
  setName: (...args) => void;
  lastName: string;
  setLastName: (...args) => void;
  passedMinRevenue: boolean;
  setPassedMinRevenue: (...args) => void;
  platform: ESellerStore;
  setPlatform: (...args) => void;
  revenue: number;
  setRevenue: (arg: number) => void;
}

export const GetStartedContext: Context<GetStarted> = createContext({
  leadId: null,
  setLeadId: () => {},
  onboardingStage: 0,
  setOnboardingStage: () => {},
  email: null,
  setEmail: () => {},
  name: null,
  setName: () => {},
  lastName: null,
  setLastName: () => {},
  passedMinRevenue: null,
  setPassedMinRevenue: () => {},
  platform: null,
  setPlatform: () => {},
  revenue: null,
  setRevenue: () => {},
});

export default function GetStartedProvider(props) {
  const history = useHistory();

  const [leadId, setLeadId] = useState(null);
  const [onboardingStage, setOnboardingStage] = useState(0);
  const [email, setEmail] = useState(null);
  const [name, setName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [passedMinRevenue, setPassedMinRevenue] = useState(true);
  const [platform, setPlatform] = useState(null);
  const [revenue, setRevenue] = useState(null);

  async function updateLead() {
    let lead;
    const id = window.localStorage.getItem('leadId');
    if (id && lead !== 'undefined') lead = await getLead(id);
    if (lead?.id) setLeadId(lead?.id);
    if (lead?.onboardingStage) setOnboardingStage(lead?.onboardingStage);
    if (lead?.email) setEmail(lead?.email);
    if (lead?.firstName) setName(lead?.firstName);
    if (lead?.lastName) setLastName(lead?.lastName);
    if (lead?.platform) setPlatform(lead?.platform);
    if (lead?.salesRevenue2) {
      setRevenue(lead?.salesRevenue2);
    }
    if (lead?.salesRevenue2 === '0') {
      setPassedMinRevenue(false);
    }
    if (window.location.pathname.startsWith('/get-started/'))
      history.push({
        pathname: lead?.onboardingStage,
        search: forwardUrlParams(),
      });
  }

  useEffect(() => {
    updateLead();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <GetStartedContext.Provider
      value={{
        leadId,
        setLeadId,
        onboardingStage,
        setOnboardingStage,
        email,
        setEmail,
        name,
        setName,
        lastName,
        setLastName,
        passedMinRevenue,
        setPassedMinRevenue,
        platform,
        setPlatform,
        revenue,
        setRevenue,
      }}
    >
      {props.children}
    </GetStartedContext.Provider>
  );
}

export const useGetStartedContext = () => useContext(GetStartedContext);
